module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid List Widget */

(function(fox) {

	fox.registerWidget('Grid_List', {

		//Widget config
		initCollection: function() {
			this.collection = this.dl;
		},

		addFieldsToDatalayer: function(plainVariables) {
			this.dl.addFields(plainVariables);
		},

		init: function() {
			this.plainVariables = [];
			this._readyToRender = false;
			if (fox.oop.instanceOf(this.getParent(), 'Grid')) {
				this.dl = this.getParent().dl;
			} else {
				this.initDl();
			}

			
			this.callParent('init', arguments);
			this.hookWrapper('addFieldsToDatalayer', this.plainVariables);

			this.forwardEvent(this.dl, 'startWorking');
			this.forwardEvent(this.dl, 'stopWorking');

			this.handleEvent(this.dl, 'loaded', fox.bind(this._loaded, this), {
				'listenHistory': true,
				prefix: 'gridListInit'
			});
		},

		initTpl: function() {
			this.callParent('initTpl', arguments);
			this.plainVariables = this.row.getPlainVariables();
		},

		activate: function() {
			if (this.dl._loadStatus != 'notLoaded') {
				this._readyToRender = true;
			}
			return this.callParent('activate', arguments);
		},

		initDl: function() {
			var dl = this.getOption('dataLayer') || this.getOption('dl');

			if (dl && (dl._objClass == 'DataLayer' || dl._widgetClass == 'Datalayer')) {
				this.dl = dl;
				if (this.dl.run) {
					this.dl.run();
				}
			} else if (dl && fox.isString(dl)) {
				this.dl = fox.wom.selectFirst(dl, this);
			} else if (this.getOption('dlClass')) {
				this.dl = fox.createDataLayer().setClass(this.getOption('dlClass'));
				this.dl.set(dl || {});
			} else if (this.getOption('dlMethod')) {
				this.dl = fox.createDataLayer().setClass(this.getOption('dlMethod'));
				this.dl.set(dl || {});
			}

			if (this.dl.run) {
				this.dl.run();
			}
		},

		//Collection successfully loaded
		_loaded: function() {
			this._readyToRender = true;
			if (this.isActive()/* && this.getParent().getOption('autoRender') === true*/) {
				this.render();
			}
		}
		
	}, 'List');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/grid/list.js
// module id = 201
// module chunks = 0